import { useLocation } from "react-router-dom";
import { BusinessOverview } from "./components/BusinessOverview";
import { SwotWizard } from "../dashboard/SwotWizard";
import { SettingsLayout } from "../settings/settings-layout";
import { ClinicNavigation } from "../settings/clinic/clinic-navigation";

/** Legacy business URLs remain local sections of the clinic workspace. */
export function MyBusiness() {
  const { pathname } = useLocation();
  return (
    <SettingsLayout current="clinic" title="Clínica" lede="Cadastro, módulos e estratégia da sua clínica.">
      <div className="space-y-6">
        <ClinicNavigation />
        {pathname === "/my-business/strategy" ? <SwotWizard /> : <BusinessOverview />}
      </div>
    </SettingsLayout>
  );
}
